module.exports = __webpack_public_path__ + "788f1dc1eb1343ab41673ca87cd1cf60.png";